import React from "react";
import { createMuiTheme } from '@material-ui/core/styles';
import { ThemeProvider } from '@material-ui/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import ReactGA from "react-ga";
import loadable from '@loadable/component';
import packageJson from "../package.json";
import { getBuildDate } from "./utils/utils";
import withClearCache from "./ClearCache";

import { Auth } from 'aws-amplify';
import "@aws-amplify/ui/dist/style.css";
import "./App.css";

const Header = loadable(() => import('./components/header/Header'));
const Footer = loadable(() => import('./components/footer/Footer'));
const Routes = loadable(() => import('./Routes'));

const ClearCacheComponent = withClearCache(MainApp);

const theme = createMuiTheme({
  typography: {
    fontFamily: [
      'Montserrat',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif'
    ].join(','),
    h5: {
      fontSize: '1.2rem',
      '@media (min-width:600px)': {
        fontSize: '1.5rem',
      },
    },
  },
  palette: {
    /*primary: {
      main: '#fd9b04',//#ff7400
    },*/
    secondary: {
      main: '#ee4035',
    },
  },
});

const trackingId = "UA-154877256-2";
ReactGA.initialize(trackingId);

function App() {
  return <ClearCacheComponent />;
}

function MainApp() {
  ReactGA.pageview(window.location.pathname + window.location.search);

  const [isAuthenticated, setIsAuthenticated] = React.useState(false);
  const [user, setUser] = React.useState(null);
  const [session, setSession] = React.useState(null);

  React.useEffect(() => {
    const storeSession = async () => {
      try {
        const session = await Auth.currentSession();
        setSession(session);
        setIsAuthenticated(true);
        const user = await Auth.currentAuthenticatedUser();
        setUser(user);
      } catch (error) {
        console.log(error);
      }
    };
   
    storeSession();
  }, []);

  const authProps = {
    isAuthenticated: isAuthenticated,
    user: user,
    setIsAuthenticated: setIsAuthenticated,
    setUser: setUser,
    session: session,
    buildDate: getBuildDate(packageJson.buildDate),
  };

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Header auth={authProps} />
      <div className="App">
        <Routes auth={authProps} />
      </div>
      <Footer />
    </ThemeProvider>
  );
}

export default App;
